var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStrAvaiSts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 9.7V14.5H15V15.5H2H1V1.5H2V8.3H5L6.1 10.8L9.7 3.5H10.4L12 7.3H15V8.8H11L9.9 6.3L6.3 13.5H5.6L4 9.7H2Z",
    fill: "#007A33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(1 1.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrAvaiSts);
export default __webpack_public_path__ + "static/media/str_avai_sts.dca40784a1f89e770864dd6dc2929931.svg";
export { ForwardRef as ReactComponent };